import styled from "styled-components"

export default {
    "WrapperDiv": styled.main`
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    `,
    "Title": styled.h1`
        ${({ theme }) => theme.font.large_bold};
        color: ${({ theme }) => theme.color.black};
    `,
    "ContentDiv": styled.div`
        margin-top: 8px;
        margin-bottom: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;

        & > p {
            ${({ theme }) => theme.font.small};
            color: ${({ theme }) => theme.color.black};
        }
    `,
    "CautionSvg": styled.img`
        width: 560px;
    `,
    "BtnDiv": styled.div`
        width: 240px;
    `,
}